import { FC } from "react";
import styles from './index.less';
import { Button } from "react-vant";

interface BottomSignProps {
  click: (value: number) => void;
  loading?: boolean
}

const ButtonRentBottom: FC<BottomSignProps> = (props) => {
  const {click, loading } = props;
  return (
    <>
      <div>
        <div className={styles.bottomButtonContainer} >
          
          <Button type='danger' className={styles.Bl} onClick={() => click(1)} loading={loading} block round>
            删除
          </Button>
          <Button  type='primary' onClick={() => click(0)} loading={loading} block round>
            编辑
          </Button>
        </div>
      </div>
    </>
  );
};

export default ButtonRentBottom